import { render, staticRenderFns } from "./uploadfile.vue?vue&type=template&id=6a537d77&scoped=true"
import script from "./uploadfile.vue?vue&type=script&lang=js"
export * from "./uploadfile.vue?vue&type=script&lang=js"
import style0 from "./uploadfile.vue?vue&type=style&index=0&id=6a537d77&lang=scss&scoped=true"
import style1 from "./uploadfile.vue?vue&type=style&index=1&id=6a537d77&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a537d77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a537d77')) {
      api.createRecord('6a537d77', component.options)
    } else {
      api.reload('6a537d77', component.options)
    }
    module.hot.accept("./uploadfile.vue?vue&type=template&id=6a537d77&scoped=true", function () {
      api.rerender('6a537d77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/courseTrain/meredu/components/uploadfile.vue"
export default component.exports